export const authenticationConst = {
    LOGOUT_SUCCESS: 'USERS_LOGOUT_SUCCESS',
    LOGOUT_FAILURE: 'USERS_LOGOUT_FAILURE',

    LOGIN_SUCCESS: 'USER_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USER_LOGIN_FAILURE',

    ACCESS_STORE_SUCCESS: 'USER_ACCESS_STORE_SUCCESS',
    ACCESS_STORE_FAILURE: 'USER_ACCESS_STORE_FAILURE',

    LEAVE_STORE_SUCCESS: 'USER_LEAVE_STORE_SUCCESS',
    LEAVE_STORE_FAILURE: 'USER_LEAVE_STORE_FAILURE',

    CLEAR: 'USER_AUTH_CLEAR'
};
